/**
 * @desc 刷新角色配置缓存
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.Response;
export function request(
  body: defs.appCenter.ViewConfigureRefreshRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/role/refresh`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
